import { render } from "./CalendarClockButton.vue?vue&type=template&id=61408eb4"
import script from "./CalendarClockButton.vue?vue&type=script&lang=js"
export * from "./CalendarClockButton.vue?vue&type=script&lang=js"
script.render = render

export default script